__webpack_require__.p = "/email-theme-switcher/referrals-hub/";